<template>
  <v-layout row>
    <v-flex xs1 lg1>
      <label class="form-label">Item {{ index + 1 }}</label>
    </v-flex>
    <v-flex xs3 lg3 class="mr-2">
      <v-text-field
        :disabled="disabled"
        v-model="description"
        :rules="validation.text"
        :maxlength="constants.LENGTH_CONTRACT_ITEM"
      ></v-text-field>
    </v-flex>
    <v-flex xs2 lg2 class="mr-2">
      <v-text-field
        :disabled="disabled"
        v-model="timeAmount"
        :rules="validation.biggerThanZero"
        :mask="validation.mask.timeAmount"
      ></v-text-field>
    </v-flex>

    <v-flex xs1 class="pt-2" v-if="removable">
      <v-icon @click="remove" style="cursor: pointer">delete</v-icon>
    </v-flex>

    <v-flex xs2 class="mr-2" v-if="!removable">
      <v-text-field
        :disabled=true
        v-model="estimatedTime"
      ></v-text-field>
    </v-flex>
    <v-flex xs2 class="mr-2" v-if="!removable">
      <v-text-field
        :disabled=true
        v-model="executedTime"
      ></v-text-field>
    </v-flex>
    <v-flex xs0 class="pt-2" v-if="!removable && !contractCopy">
      <v-switch
        v-model="active"
        v-on="activeState"
        :disabled="contractInUse"
      ></v-switch>
    </v-flex>
    <v-flex xs1 class="pt-2" v-if="contractInUse && !contractCopy">
      <span>**</span>
    </v-flex>
  </v-layout>
</template>

<script>
import constants from "@/helpers/constants";
import validation from "@/helpers/validation";

export default {
  props: {
    model: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
      default: 0,
    },
    suffix: {
      type: String,
      required: true,
      default: "",
    },
    isInUse: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      constants,
      validation,

      description: this.model.description,
      timeAmount: this.model.timeAmount,
      estimatedTime: this.model.estimatedTime,
      executedTime: this.model.executedTime,
      active: this.model.active,
      isContractItemInUse: this.model.isContractItemInUse,
    };
  },

  computed: {
    removable() {
      return this.model.id === null;
    },
    activeState() {
      if (this.model.active === true) {
        this.active = true;
      }
    },
    contractInUse() {
      if (this.isContractItemInUse === true) {
        return true;
      }
      return false;
    },
    contractCopy() {
      if (this.$route.name === "contractCopy") {
        return true;
      }
      return false;
    },
  },

  watch: {
    description: "update",
    timeAmount: "update",
    active: "update",
  },

  methods: {
    update() {
      this.$emit("change", {
        id: this.model.id,
        uuid: this.model.uuid,
        description: this.description,
        timeAmount: this.timeAmount,
        active: this.active,
      });
    },
    remove() {
      this.$emit("remove", this.model.uuid);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractItem.vue